import React from 'react';
import { bonuses } from '../data/bonuses';
import { Eyebrow } from './Eyebrow';

/**
 * NOTE (pre-launch dependency): the bonus cover images in data/bonuses.ts are
 * served from cdn.magicpatterns.com, which is prototype hosting. Re-upload them
 * to the production asset host / CDN and update the URLs before going live.
 */
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="bg-night-900 py-16 sm:py-24" data-id="element-25" data-mp="frtkrd3rjukz">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-26" data-mp="1whr791cga5n">
        <div className="max-w-2xl" data-id="element-27" data-mp="5x1n69a6l7q7">
          <Eyebrow data-id="element-28" data-mp="5tvy2u1jy5uh">Included today at no extra cost</Eyebrow>
          <h2 id="bonuses-heading" className="mt-5 font-display text-4xl leading-[0.98] text-cream sm:text-6xl" data-id="element-29" data-mp="3o2n2jujn9yhj">
            Six free <span className="text-amber" data-id="element-30" data-mp="1ma8mz24kp64a">bonus gifts</span>
          </h2>
          <p className="mt-5 font-serif text-lg italic text-cream-soft" data-id="element-31" data-mp="1mb1jla9tif8p">
            Real value <span className="text-cream-muted line-through" data-id="element-32" data-mp="1r8tbw5edk3df">$300</span> &mdash;{' '}
            <span className="text-amber" data-id="element-33" data-mp="3idelk4c2g04c">today completely free with the Arsenal.</span>
          </p>
        </div>

        <ul className="mt-8 grid gap-5 sm:mt-12 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6" data-id="element-34" data-mp="3detvgxqj2wtm">
          {bonuses.map(bonus => <li key={bonus.number} className="flex flex-col overflow-hidden rounded-2xl border border-night-600 bg-night-800" data-id="element-35" data-mp="3r8uodaustpm2">
              <img src={bonus.image} alt={`Cover of ${bonus.title}`} className="aspect-[4/3] w-full object-cover" data-id="element-36" data-mp="2zgdgykmfc20x" />
              <div className="flex flex-1 flex-col p-6 sm:p-7" data-id="element-37" data-mp="38giiie4xs676">
                <div className="flex items-center justify-between gap-4" data-id="element-38" data-mp="33h5p1ajk80vm">
                  <span className="text-[11px] font-semibold uppercase tracking-label text-cream-muted" data-id="element-39" data-mp="33ja1igviy87i">
                    Bonus {bonus.number}
                  </span>
                  <span className="rounded-full bg-ember px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.12em] text-cream" data-id="element-40" data-mp="iq55mvhl73ar">
                    {bonus.value} &middot; Free
                  </span>
                </div>
                <h3 className="mt-5 font-display text-2xl leading-tight text-cream" data-id="element-41" data-mp="3hg6gm5celv6z">{bonus.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-cream-soft" data-id="element-42" data-mp="3lhi5g8ngece4">{bonus.description}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}